import "./_container-button.scss";

import classNames from "classnames";

import Button from "../Button";
import {ButtonProps} from "../Button.types";

function ContainerButton({children, customClassName, ...otherProps}: ButtonProps) {
  return (
    <Button
      typography={"body"}
      customClassName={classNames(
        "container-button",
        "font-weight--medium",
        customClassName
      )}
      {...otherProps}>
      {children}
    </Button>
  );
}

export default ContainerButton;
